import { PropTypes } from 'prop-types';
import { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import AccionaButton from '../../../../components/AccionaButton';
import AccionaLabel from '../../../../components/AccionaLabel';
import AccionaTable from '../../../../components/AccionaTable';
import AccionaTableButton from '../../../../components/AccionaTable/AccionaTableButton';
import Modal from '../../../../components/Modal';
import RemoveModal from '../../../../components/RemoveModal';
import ViewImage from '../../../../components/ViewImage';
import { MainContext } from '../../../../context/MainContext';
import { getFile } from '../../../../services/api/files';
import * as PreRegisteredDocumentsActions from '../../../../services/redux/preRegisteredDocuments/actions';
import PreRegisteredDatas from './components/PreRegisteredDatas';
import { COLUMNS_HEADERS } from './columns';
import WithBackButton from '../../../../layout/WithBackButton';
import styles from './index.module.scss';

const { actionsWrapper } = styles;

const PreRegisteredDoc = ({
  getPreRegisteredDocumentsList,
  deletePreRegisterDocuments,
}) => {
  const intl = useIntl();
  const { setLoading, setError } = useContext(MainContext);

  const [selectedImg, setSelectedImg] = useState(null);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [selectedDatas, setSelectedDatas] = useState({
    state: null,
    doc: null,
  });
  const [selectedRows, setSelectedRows] = useState([]);

  const onClickViewIcon = (preRegisteredDocument) => {
    setLoading(true);

    getFile(preRegisteredDocument.image_name, 'delivery')
      .then((value) => {
        //Visualizamos la el fichero cargado
        setSelectedImg(URL.createObjectURL(value.data));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError({
          status: error.status ? error.status : 502,
          errorType: 'LOAD_FILE_ERROR',
        });
      });
  };

  const onClickPreRegisteredIcon = (preRegisteredDocument) => {
    setSelectedDatas({
      state: true,
      document: preRegisteredDocument,
    });
  };

  const deletePreregisterActionOnBulk = () => setShowRemoveModal(true);

  const deletePreregisterAction = (preregister) => {
    setShowRemoveModal(true);
    setSelectedRows([preregister]);
  };

  const handleOnBulkDeleting = () => {
    setShowRemoveModal(false);
    selectedRows.forEach((row) => {
      deletePreRegisterDocuments(row);
    });
    setSelectedRows([]);
  };

  const onCancelModal = () => {
    setSelectedImg(null);
    setSelectedDatas({ state: null, document: null });
  };

  return (
    <>
      <Modal
        width={620}
        open={Boolean(selectedDatas.state)}
        onCancel={onCancelModal}
        title={
          selectedDatas.state
            ? selectedDatas.document.docket_number.toString()
            : ''
        }
        closable={true}
        id="PreRegisteredDataModal"
      >
        <PreRegisteredDatas preRegisteredDoc={selectedDatas.document} />
      </Modal>
      <RemoveModal
        entity="preRegisteredDocuments"
        msg={intl.formatMessage({
          id:
            selectedRows.length > 1
              ? 'delete.preRegisterDocuments'
              : 'delete.preRegisterDocuments',
        })}
        onOk={handleOnBulkDeleting}
        onCancel={() => setShowRemoveModal((prev) => !prev)}
        hidden={!showRemoveModal}
      />
      <ViewImage
        img={selectedImg}
        visible={selectedImg}
        onCancel={onCancelModal}
      />
      <div className={`row ${actionsWrapper}`}>
        <div className="col-sm-12">
          <AccionaButton
            id="deleteBtn"
            htmlType="submit"
            disabled={!selectedRows.length}
            onClick={deletePreregisterActionOnBulk}
            msg={intl.formatMessage({ id: 'button.delete' })}
            classIcon="icon fas fa-trash-alt"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AccionaTable
            isSelectionDisabled={(preRegister) => preRegister.prm_data}
            columns={COLUMNS_HEADERS}
            getItems={getPreRegisteredDocumentsList}
            entity="preRegisteredDocuments"
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            actions={(preregister) => (
              <>
                {preregister.model === 'other' ? (
                  <AccionaTableButton
                    onClick={() => onClickViewIcon(preregister)}
                    type="view"
                    toolTip={intl.formatMessage({
                      id: 'viewAction.preRegisteredDocuments',
                    })}
                  />
                ) : null}
                <AccionaTableButton
                  onClick={() => onClickPreRegisteredIcon(preregister)}
                  type="details"
                  toolTip={intl.formatMessage({
                    id: 'preRegisteredAction.preRegisteredDocuments',
                  })}
                />
                {!preregister.prm_data ? (
                  <AccionaTableButton
                    onClick={() => deletePreregisterAction(preregister)}
                    type="delete"
                    toolTip={intl.formatMessage({
                      id: 'preRegisteredAction.deletePreRegisteredDocuments',
                    })}
                  />
                ) : (
                  <AccionaLabel>PRM</AccionaLabel>
                )}
              </>
            )}
          />
        </div>
      </div>
    </>
  );
};
const mapStateToProps = ({ preRegisteredDocuments }) => ({
  preRegisteredDocuments: preRegisteredDocuments.list,
  fetching: preRegisteredDocuments.fetching,
  errorMessagesPreRegisteredDocuments: preRegisteredDocuments.errorMessages,
});

const matchDispachToProps = {
  getPreRegisteredDocumentsList:
    PreRegisteredDocumentsActions.getPreRegisteredDocuments,
  deletePreRegisterDocuments:
    PreRegisteredDocumentsActions.deletePreRegisterDocuments,
};

PreRegisteredDoc.defaultProps = {
  errorMessagesPreRegisteredDocuments: {},
  selectedRows: [],
};

PreRegisteredDoc.propTypes = {
  getPreRegisteredDocumentsList: PropTypes.func.isRequired,
  deletePreRegisterDocuments: PropTypes.func.isRequired,
};

export default WithBackButton(
  connect(mapStateToProps, matchDispachToProps)(PreRegisteredDoc),
);
